<template>
	<!-- 多行输入框 -->
	<div @click="setEditIndex(index)">
		<el-row :gutter="10" style="margin-left: 5px">
			<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{ number }}</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
				<el-input placeholder="请输入题目内容" @focus="showAdvance" @blur="updateQuestion()" v-model="question.questionsName" autosize></el-input>
			</el-col>
			<el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
				<i class="el-icon-delete delete" v-if="index == editIndex" @click="questiondel(question.id)"></i>
				<el-badge v-if="question.displayscriptcount || question.jumpscriptcount" :value="question.displayscriptcount + question.jumpscriptcount" class="item">
					<i class="el-icon-share" @click="() => $emit('jumpshow', question.id)"></i>
				</el-badge>
				<i class="el-icon-rank item drag-handle"></i>
			</el-col>
		</el-row>
		<el-row :gutter="10" style="margin-top: 12px !important" v-for="(childItem, childindex) in question.optionList" :key="index + '_' + childindex">
			<div @click="setEditOptionIndex(childindex)">
				<el-row>
					<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title" style="margin-left: 50px; margin-bottom: 24px">
						<fake-input
							type="text"
							v-if="question.inputBoxSetting == 0"
							:style="{ height: question.inputBoxSize + 'px' }"
							style="
                border: 1px solid #ccc !important;
                width: 400px;
                border-radius: 3px;
              "
							placeholder=""
						/>
						<fake-textarea :style="{ height: question.inputBoxSize + 'px' }" placeholder="" v-if="question.inputBoxSetting == 1" />
					</el-col>
				</el-row>
			</div>
			<div @click="setEditOptionIndex(childindex)">
				<el-row>
					<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title" style="margin-left: 50px">
						<!-- <div class="inputvalue"></div> -->
					</el-col>
					<el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3" class="el_item_option item_container_title"></el-col>
				</el-row>
			</div>
		</el-row>
		<!-- <el-row :gutter="10" style="margin-top: 12px !important;" v-if="index==editIndex">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                <span style="color: #FFF;">占</span>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                    class="el_item_option item_container_title">
                <i class="el-icon-plus el-icon-common"
                   @click="wjaddquestionoption(question.optionList,question,0)">添加选项</i>
                <i class="el-icon-s-fold el-icon-common"
                   @click="wjaddquestionoption(question.optionList,question,2)">批量添加</i>
                <i class="el-icon-menu el-icon-common"
                   @click="wjaddquestionoption(question.optionList,question,1)">添加【其他】</i>
            </el-col>
        </el-row> -->
	</div>
</template>
<script>
import FakeInput from './FakeInput.vue';
import FakeTextarea from './FakeTextarea.vue';
export default {
	components: { FakeInput, FakeTextarea },
	data() {
		return {};
	},
	props: {
		number: { type: Number, default: 0 },
		question: {},
		editOptionIndex: { type: String, default: '0_0' },
		editIndex: { type: Number, default: 0 },
		isExistPage: { type: Boolean, default: false },
		index: { type: Number, default: 0 }
	},
	methods: {
		updateQuestion() {
			this.$emit('wjupdquestionoption', this.question);
		},
		wjupdoption(item) {
			this.$emit('wjupdoption', item);
		},
		wjaddquestionoption(optionList, item, type = 1) {
			this.$emit('wjaddquestionoption', optionList, item, type);
		},
		wjdelquestionoption(options, item, childindex) {
			this.$emit('wjdelquestionoption', options, item, childindex);
		},
		showAdvance(e) {
			this.$emit('showAdvance', e);
		},
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
		setEditOptionIndex(childIndex) {
			this.$emit('setEditOptionIndex', childIndex);
		},
		questiondel(id) {
			this.$emit('questiondel', id);
		}
	},
	created() {
		console.log('questionblankmult', this.question);
	}
};
</script>

<style scoped>
/* .inputvalue{
        border: 1px solid rgb(154, 145, 145);
        width: 770px;
        height: 35px;
    } */
.delete,
.item {
	font-size: 22px !important;
	line-height: 40px !important;
	margin-right: 30px !important;
	text-align: right;
	float: right;
	cursor: pointer;
}
.item .el-badge__content.is-fixed {
	top: 10px;
}
.item.drag-handle {
	cursor: move;
}
.el_item_option {
	line-height: 40px;
	height: 44px;
}

.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.askxh {
	line-height: 40px;
	text-align: right;
}

.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

.item_container_title:hover {
	//border: 1px darkgrey dashed;
}
</style>
